import produce, { Draft, enableES5 } from 'immer';
import { Input } from '../models/store';
import { ActionTypes } from '../models/actions';
import {
  HYDRATE_STORE_FROM_SESSION,
  USER_CHANGED_INPUT_TEXT,
  USER_CLICKED_DELETE_TEXT,
  USER_CLICKED_UNDO_DELETE_TEXT,
} from '../models/actions/names';

enableES5();

const initial = { inputPara: '', numberOfChars: 0, numberOfWords: 0, forceUpdateInput: false };

const initState = {
  ...initial,
  previousState: {
    ...initial,
  },
};

export const inputReducer = produce((draft: Draft<Input>, action: ActionTypes) => {
  switch (action.type) {
    case USER_CHANGED_INPUT_TEXT:
      draft.inputPara = action.payload.inputPara;
      draft.numberOfChars = action.payload.numberOfChars;
      draft.numberOfWords = action.payload.numberOfWords;
      draft.forceUpdateInput = false;
      break;

    case USER_CLICKED_DELETE_TEXT: {
      delete draft.previousState;
      const oldState = JSON.parse(JSON.stringify(draft));
      Object.assign(draft, initState);
      draft.previousState = oldState;

      break;
    }
    case USER_CLICKED_UNDO_DELETE_TEXT: {
      draft.inputPara = draft.previousState?.inputPara || initState.inputPara;
      draft.numberOfChars = draft.previousState?.numberOfChars || initState.numberOfChars;
      draft.numberOfWords = draft.previousState?.numberOfWords || initState.numberOfWords;
      draft.previousState = initState;
      draft.forceUpdateInput = true;
      break;
    }
    case HYDRATE_STORE_FROM_SESSION: {
      try {
        if (action.payload.src === 'INPUT') {
          return { ...draft, ...action.payload.store };
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
      break;
    }
  }
}, initState);
